import { render } from "./Welcome.vue?vue&type=template&id=317d1a6e&scoped=true"
import script from "./Welcome.vue?vue&type=script&setup=true&lang=js"
export * from "./Welcome.vue?vue&type=script&setup=true&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=317d1a6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317d1a6e"],['__file',"resources/js/Pages/Welcome.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "317d1a6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('317d1a6e', __exports__)) {
    api.reload('317d1a6e', __exports__)
  }
  
  module.hot.accept("./Welcome.vue?vue&type=template&id=317d1a6e&scoped=true", () => {
    api.rerender('317d1a6e', render)
  })

}


export default __exports__